import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BookingProvider } from "./context/BookingContext";
import ScrollToTop from "./components/ScrollToTop";
import Layout from "./components/Layout";
import Preloader from "./components/Preloader";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ReviewsPage from "./pages/ReviewsPage";
import ContactPage from "./pages/ContactPage";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";
import { registerServiceWorker } from "./lib/push";

function App() {
  const [loading, setLoading] = React.useState(() => !sessionStorage.getItem("viimii_seen"));
  const finishLoad = () => { sessionStorage.setItem("viimii_seen", "1"); setLoading(false); };

  React.useEffect(() => {
    registerServiceWorker();
  }, []);

  return (
    <div className="App">
      {loading && <Preloader onDone={finishLoad} />}
      <BrowserRouter>
        <BookingProvider>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BookingProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
